// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail_detail__UM1BW"};